<template>
  <div>
    <button @click="onResetClick">Reset</button>
    <button @click="onRandomizeClick">Random</button>
    <button @click="onStepForwardClick" :disabled="playing">
      Step Forward
    </button>
    <button @click="onPlayClick" :disabled="playing">Play</button>
    <button @click="onStopClick" :disabled="!playing">Stop</button>
    <input
      type="range"
      min="10"
      max="2000"
      step="10"
      :value="intervalValue"
      @input="$emit('update:intervalValue', $event.target.value)"
    />{{ intervalValue }}ms
  </div>
</template>

<script>
export default {
  props: {
    playing: { type: Boolean, required: true },
    intervalValue: { required: true },
  },
  methods: {
    onResetClick() {
      this.$emit("reset");
    },
    onRandomizeClick() {
      this.$emit("randomize");
    },
    onStepForwardClick() {
      this.$emit("stepForward");
    },
    onPlayClick() {
      this.$emit("play");
    },
    onStopClick() {
      this.$emit("stop");
    },
  },
  emits: [
    "reset",
    "randomize",
    "stepForward",
    "play",
    "stop",
    "update:intervalValue",
  ],
};
</script>

<style></style>
